<template>
  <v-container>
    <!-- BOC:[breadcrumbs] -->
    <ABreadcrumb :items="breadcrumbs"></ABreadcrumb>
    <!-- EOC -->
    <AError
      v-if="api.isError"
      :api="api"
  :callbackReset="() => (api.isError = false)"
    ></AError>
    <v-card class="mx-auto pa-3" max-width="800" outlined min-height="200">
      <v-card-title>New Mission</v-card-title>
      <div class="d-flex align-center justify-space-around">
        <div v-if="mochiId" class="form-content text-center">
          <v-form ref="formName" v-model="valid" lazy-validation>
            <div class="text-center pt-3">
              <Syllabus
                ref="syllabus"
                :callbackSelect="selectSyllabus"
                :callbackError="showError"
              />
            </div>
            <div v-if="syllabus && syllabus.key" class="text-center pt-4">
              <Chapter
                ref="chapter"
                :syllabus="syllabus"
                :callbackSelect="selectChapter"
                :callbackError="showError"
                @input="form.chapterKey = $event"
              />
            </div>
            <div v-if="chapter && chapter.key" class="text-center pt-4">
              <Question
                ref="question"
                :chapter="chapter"
                :callbackSelect="selectQuestion"
                :callbackError="showError"
                @input="form.questionKey = $event"
              />
            </div>
            <div class="text-center pt-3">
              <v-btn
                :loading="api.isLoading"
                width="75%"
                color="primary"
                dark
                rounded
                @click="submit()"
              >
                Submit
              </v-btn>
            </div>
            <div class="text-center pt-2">
              <v-btn
                width="75%"
                text
                color="primary"
                rounded
                @click="$router.go(-1)"
              >
                Cancel
              </v-btn>
            </div>
          </v-form>
        </div>
        <div v-if="!mochiId && !playerApi.isLoading">
          <p>Mochi not found</p>
          <v-btn
            width="75%"
            text
            color="primary"
            rounded
            @click="$router.go(-1)"
          >
            Cancel
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-container>
</template>
    
    <script>
import Syllabus from "@/components/Bread/Mission/Syllabus";
import Chapter from "@/components/Bread/Mission/Chapter";
import Question from "@/components/Bread/Mission/Question";
import { mapState } from "vuex";
export default {
  components: {
    Syllabus,
    Chapter,
    Question,
  },
  computed: mapState({
    //
  }),
  props: [
    //
  ],
  data: () => ({
    //BOC:[breadcrumbs]
    breadcrumbs: [],
    //EOC
    syllabus: {},
    chapter: {},
    question: null,
    nameRules: [],
    mochiId: null,
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    playerApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
     form: {},
  }),
  created() {
    //BOC:[breadcrumbs]
    this.breadcrumbs = [
      {
        text: "Dashboard",
        to: { name: "PageFamilyDashboard" },
        exact: true,
      },
      // Parent user page
      {
        text: "User",
        to: { name: "PageFamilyUserRead", params: { id: this.$route.params.parentId } },
        exact: true,
      },
      {
        text: "New Mission",
        to: { name: "PageFamilyUserMissionAdd" },
        exact: true,
      },
    ];
    //EOC
    //

    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
    };
    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
    };

    this.api.callbackSuccess = () => {
      this.api.isLoading = false;
      this.$router.push({
  name: "PageFamilyUserRead",
  params: { id: this.$route.params.parentId },
      });
    };

    this.playerApi.method = "GET";

    this.playerApi.url =
      this.$api.servers.game +
      "/api/v1/" +
      this.$_getLocale() +
      "/user/" +
      this.$route.params.parentId +
      "/player";

    this.playerApi.callbackReset = () => {
      this.playerApi.isLoading = true;
      this.playerApi.isError = false;
    };

    this.playerApi.callbackError = (e) => {
      this.playerApi.isLoading = false;
      this.playerApi.isError = true;
      this.playerApi.error = e;
    };

    this.playerApi.callbackSuccess = (resp) => {
      this.playerApi.isLoading = false;
      this.mochiId = resp.mochiId;
      if (this.mochiId) {
        this.api.url =
          this.$api.servers.game +
          "/api/v1/" +
          this.$_getLocale() +
          "/backend/player/" +
          this.mochiId +
          "/mission/add";
      }
    };
  },
  mounted() {
    this.$api.fetch(this.playerApi);
  },
  watch: {
    name: function () {
      this.nameRules = [];
    },
  },
  methods: {
    // updateBreadcrumb(resp) {
    //   this.breadcrumbs.push({
    //     text: "Dashboard",
    //     to: { name: "PageEducatorDashboard" },
    //     exact: true,
    //   });
    //   this.breadcrumbs.push({
    //     text: resp.name,
    //     to: { name: "PageEducatorInstitutionDashboard",params:{id:this.$route.params.parentId} },
    //     exact: true,
    //   });
    //   this.breadcrumbs.push({
    //     text: 'Classrooms',
    //     to: { name: "PageEducatorInstitutionClassroom",params:{id:this.$route.params.parentId} },
    //     exact: true,
    //   });
    //   this.breadcrumbs.push({
    //     text: "New Classroom",
    //     to: { name: "PageEducatorInstitutionClassroomAdd" },
    //     exact: true,
    //   });
    // },
    close() {
      this.$router.push({
  name: "PageFamilyUserRead",
  params: { id: this.$route.params.parentId },
      });
    },
   selectSyllabus(item) {
      this.syllabus = item;
      var that = this;
      setTimeout(() => {
        that.$refs["chapter"].fetch();
      }, 100);
    },
    selectChapter(item) {
      this.chapter = item;
      this.form.chapterKey = item.key;
      var that = this;
      setTimeout(() => {
        that.$refs["question"].fetch();
      }, 100);
    },
    selectQuestion(item) {
      this.question = item;
      this.form.questionKey = item.key;
    },
    submit() {
      this.api.params = this.$_.clone(this.form);
      this.$api.fetch(this.api);
    },
  },
};
</script>
<style scoped>
.menu-item {
  border: 1px solid black;
  margin: 3px;
}
.form-content {
  width: 300px !important;
}
</style>